/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SpecialCommissionType {
    Unentgeltlich = 'Unentgeltlich',
    JahreshonorarInEurMitProvision = 'JahreshonorarInEurMitProvision',
    JahreshonorarInPercentMitProvision = 'JahreshonorarInPercentMitProvision'
  }

    export const SpecialCommissionTypeTranslocoMap: Record<SpecialCommissionType, string> = {
    [SpecialCommissionType.Unentgeltlich]: 'specialCommissionType.unentgeltlich',
    [SpecialCommissionType.JahreshonorarInEurMitProvision]: 'specialCommissionType.jahreshonorarInEurMitProvision',
    [SpecialCommissionType.JahreshonorarInPercentMitProvision]: 'specialCommissionType.jahreshonorarInPercentMitProvision',
    };

    export const SpecialCommissionTypeOptions = [
  { value: SpecialCommissionType.Unentgeltlich, labelKey: 'specialCommissionType.unentgeltlich' },
  { value: SpecialCommissionType.JahreshonorarInEurMitProvision, labelKey: 'specialCommissionType.jahreshonorarInEurMitProvision' },
  { value: SpecialCommissionType.JahreshonorarInPercentMitProvision, labelKey: 'specialCommissionType.jahreshonorarInPercentMitProvision' },
    ];

